<template>
  <v-dialog id="dialog_Historico" v-model="showDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card v-if="!bShowDetalleProceso">
        <v-toolbar dark color="primary">
          <v-toolbar-title>Historico del Proceso</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="showDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <div id="div_InfoLlave" class="ma-2 text-h5">
          Llave: {{ sLlave }}
        </div>

        <v-list id="Lista_Historico" three-line v-if="aHistorico.length > 0">
          <template v-for="(item, index) in aHistorico"> 
            <v-list-item  
              :id="`listItelm_${index}`" 
              @click="selectItem(index)" 
              :class="{ 'blue lighten-4': registroSelect === index }">
              <v-list-item-content>
                <v-list-item-title>
                  <strong>Acción:</strong> {{ item.sTransicion }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  Fecha: {{ __onConvertirFecha(item.Fecha) }}
                </v-list-item-subtitle>
                <v-list-item-subtitle>
                  Estado Inicial: {{ item.sEstadoInicial }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider ></v-divider>   
          </template>
        </v-list>
        <v-alert v-else-if="!bCargando" type="info" class="ma-3">
          No hay datos de histórico para este proceso.
        </v-alert>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="loadMore" :loading="bCargando" :disabled="!bCargarMas">
            Cargar más
          </v-btn>
        </v-card-actions>
      </v-card>
      <viewInfoHistoricoFD v-else :oInfoSelected="aHistorico[registroSelect]" @closeViewInfoHistoricoFD="bShowDetalleProceso = false"></viewInfoHistoricoFD>
    </v-dialog>
</template>

<script>
import axiosServices from "@/services/axiosServices.js";
import Hora_Fecha from '@/utils/Hora_Fecha';
import viewInfoHistoricoFD from '@/components/workflow/viewInfoHistoricoFD.vue';

export default {
  name: 'HistoricoProceso',
  components: {
    viewInfoHistoricoFD,
  },
  props: {
    value: Boolean,
    idProceso: {
      type: [String, Number],
      required: true,
    },
    sLlave: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      bCargando: false,
      aHistorico: [],
      pagina: 1,
      noRegistro: 5, 
      bCargarMas: true,
      registroSelect: null,
      bShowDetalleProceso: false,
    };
  },
  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.aHistorico = [];
        this.pagina = 1;
        this.bCargarMas = true;
        this.registroSelect = null;
        this.CargarHistorico();
      }
    },
  },
  methods: {
    async CargarHistorico() {
      if (this.bCargando || !this.bCargarMas) return;

      this.bCargando = true;
      try {
        const requestParams = `sllave=${this.sLlave}&pagina=${this.pagina}&noRegistros=${this.noRegistro}`;
        const oResponse = await axiosServices.getConfiguration(`workflow/${this.idProceso}/historico`, true, requestParams);

        if (oResponse.nStatusCode === 200 && oResponse.aData) {
          this.aHistorico.push(...oResponse.aData);
          if (oResponse.aData.length < this.noRegistro) {
            this.bCargarMas = false; 
          }
        } else {
          this.bCargarMas = false;
        }
      } catch (error) {
        // error en axios.
        this.bCargarMas = false;
      } finally {
        this.bCargando = false;
      }
    },
    loadMore() {
      this.pagina++;
      this.CargarHistorico();
    },
    selectItem(index) {
      this.registroSelect = index;
      this.bShowDetalleProceso = true
    },
    __onConvertirFecha(Fecha){
      return Hora_Fecha.getDateTimeBy(Number(Fecha.$date.$numberLong));
    }
  },
};
</script>

<style scoped>
.blue.lighten-4 {
  background-color: #e3f2fd !important;
  border-left: 5px solid #2196f3;
}
</style>
